/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, Typography, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Styles from "./AddMemberModal.style";
import Modal from "../../common/Modal/Modal";
import Button from "../../common/Button";
import { CommonStyles } from "../../common/Button/commonButtonStyle";
import Dropdown from "../../common/new/Dropdown/Dropdown";
import InputField from "../../common/new/InputField/InputField";
import {
  AlertStatus,
  // MEMBER_OPTIONS,
  RELATION_OPTIONS,
} from "../../../contants";
import { RELATION_FIELDS } from "../../../contants/formFields";
import AddPlusIcon from "../../../assets/svg/addPlusIcon";
import Delete from "../../../assets/svg/Delete";

// import Switch from "../../common/SwitchButton";

const createRelation = (data) => ({
  id: data.id,
  name: data.name ?? "",
  age: data.age ?? null,
  relationType: data.relationType ?? "",
  memberOrNot: data.memberOrNot ?? "NO",
  remarks: data.remarks ?? "",
});

const isValidFamiltMember = (data) =>
  Boolean(
    data.name &&
      data.relationType &&
      data.age &&
      data.memberOrNot &&
      data.remarks
  );

function AddMemberModal({
  open,
  onClose,
  setRelationData,
  toast,
  memberRelationship,
}) {
  const [relation, setRelation] = useState([createRelation({ id: uuidv4() })]);
  const addRelation = () => {
    setRelation((prev) => [...prev, createRelation({ id: uuidv4() })]);
  };

  const deleteMember = (id) => {
    setRelation((prev) => prev.filter((f) => f.id !== id));
  };

  const updateMember = (updatedField, id) => {
    const index = relation.findIndex((member) => member.id === id);

    const oldFamilyMember = relation[index];
    const newFamilyMember = {
      ...oldFamilyMember,
      ...updatedField,
    };

    const newFamilyMembers = [...relation];
    newFamilyMembers[index] = newFamilyMember;
    setRelation(newFamilyMembers);
  };

  const getRelations = () => {
    if (relation.length) {
      return relation.reduce((acc, curr) => {
        if (isValidFamiltMember(curr)) {
          const member = { ...curr };
          delete member.id;
          acc.push(member);
        }
        return acc;
      }, []);
    }
    return [];
  };

  const onFormSubmit = (event) => {
    event.preventDefault();
    const payload = {
      relations: getRelations(),
    };

    setRelationData(payload);
    toast.show("Successfully Done", AlertStatus.SUCCESS);
    setTimeout(() => {
      onClose();
    }, 2000);
  };

  useEffect(() => {
    if (memberRelationship && memberRelationship.length > 0) {
      const initialRelations = memberRelationship.map((data) => ({
        id: data.id || uuidv4(),
        name: data.name || "",
        age: data.age || null,
        relationType: data.relationType || "",
        memberOrNot: data.memberOrNot || "",
        remarks: data.remarks || "",
      }));
      setRelation(initialRelations);
    } else {
      setRelation([createRelation({ id: uuidv4() })]);
    }
  }, [memberRelationship]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{
        maxHeight: "95%",
        maxWidth: "95%",
        overflow: "scroll",
        borderRadius: "14px",
        background: "#FFF",
      }}
    >
      <Box style={Styles.container}>
        <form onSubmit={onFormSubmit}>
          {/* <Box style={Styles.topContainer}>
            <Typography style={Styles.title}>
              Add Non Practicing Member
            </Typography>
          </Box> */}
          <Box
            style={{
              borderRadius: "35px",
              background: "#196AAB",
              width: "258px",
              height: "44px",
              flexShrink: "0",
              marginBottom: "-20px",
              position: "relative",
              zIndex: "1",
              marginLeft: "45px",
              paddingTop: "10px",
            }}
          >
            <Typography
              variant="title3"
              style={{
                color: "#FFF",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "Noto Sans",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                padding: "11px 18px 13px 17px",
                margin: "0",
              }}
            >
              Add Non Practicing Member
            </Typography>
          </Box>
          <Box style={Styles.divider} />
          <Box
            style={{
              borderRadius: "5px 5px 5px 5px",
              border: "1px solid #C2D4EB",
              background: "#FFF",
              padding: "20px 20px 20px 20px",
              borderBottom: "9px solid #196AAB",
              margin: "0px 5px",
            }}
          >
            <Box
              style={{
                marginLeft: "30px",
                marginTop: "20px",
                margin: "20px 0px",
              }}
            >
              {relation.map((member, index) => (
                <Box style={{ display: "flex", gap: "5px", padding: "10px" }}>
                  <InputField
                    value={member.name && member.name}
                    name={RELATION_FIELDS.RELATED_MEMBER}
                    label="Name"
                    onChange={(e) =>
                      updateMember({ name: e.target.value }, member.id)
                    }
                    required
                  />

                  <InputField
                    name={RELATION_FIELDS.MEMBER_AGE}
                    value={member.age != null ? member.age : ""}
                    label="Age"
                    type="number"
                    onChange={(e) =>
                      updateMember({ age: e.target.value }, member.id)
                    }
                    disabled={!member.name}
                    required
                    InputProps={{ inputProps: { min: 1 } }}
                  />

                  <Dropdown
                    value={member.relationType && member.relationType}
                    name={RELATION_FIELDS.RELATION_TYPE}
                    options={RELATION_OPTIONS}
                    label="Relation"
                    onChange={(e) =>
                      updateMember({ relationType: e.target.value }, member.id)
                    }
                    disabled={!member.name || !member.age}
                    // required
                    inputProps={{ required: true }}
                    sx={{ height: "41px" }}
                  />
                  {/* <Dropdown
                    value={member.memberOrNot && member.memberOrNot}
                    name={RELATION_FIELDS.MEMBER_OR_NOT}
                    options={MEMBER_OPTIONS}
                    label="Member Or Not"
                    onChange={(e) =>
                      updateMember({ memberOrNot: e.target.value }, member.id)
                    }
                    disabled={
                      !member.name || !member.age || !member.relationType
                    }
                    // required
                  /> */}
                  {/* <Switch /> */}
                  <InputField
                    value={member.remarks && member.remarks}
                    name={RELATION_FIELDS.REMARK}
                    label="Remarks"
                    onChange={(e) =>
                      updateMember({ remarks: e.target.value }, member.id)
                    }
                    required
                  />
                  <Grid
                    item
                    xs={6}
                    md={2.7}
                    sx={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "row",
                      paddingLeft: "40px",
                    }}
                  >
                    <Box
                      style={{
                        ...Styles.itemNew,
                        ...Styles.colName,
                      }}
                      onClick={() => deleteMember(member.id)}
                    >
                      {index === 0 && (
                        <Typography
                          fontSize="12px"
                          style={{
                            position: "absolute",
                            top: -16,
                          }}
                        >
                          Action
                        </Typography>
                      )}
                      <Delete />
                    </Box>
                  </Grid>
                </Box>
              ))}
            </Box>
            <Box style={{ marginTop: "30px" }}>
              <Typography
                as="span"
                style={Styles.addLink}
                onClick={addRelation}
              >
                <AddPlusIcon />
                Add Another Member
              </Typography>
            </Box>
          </Box>
          <Box style={Styles.divider} />
          <Box
            style={{
              display: "flex",
              // gap: 5,
              justifyContent: "end",
              margin: "20px 20px 20px 0px",
              gap: "20px",
            }}
          >
            <Button
              variant="outlined"
              onClick={onClose}
              style={CommonStyles.buttonStyle}
              label="Cancel"
            />
            <Button
              variant="contained"
              // onClick={handleSubmit}
              style={CommonStyles.buttonStyle}
              label="Submit"
              type="submit"
            />
          </Box>
        </form>
      </Box>
    </Modal>
  );
}

export default AddMemberModal;
